import apiClient from './client';

/**
 * Distribution API Service
 * Handles TRONC distribution preview and approval
 */
export const distributionApi = {
  /**
   * Preview distribution calculation
   */
  preview: ({ ruleId, troncAmount, locationId, periodStart, periodEnd }) => {
    return apiClient.post('/distribution/preview', {
      ruleId,
      troncAmount,
      locationId,
      periodStart,
      periodEnd
    });
  },

  /**
   * Approve and finalize distribution
   * Supports both old and new API formats
   */
  approve: ({ troncRecordIds, distributionRuleId, allocations, distributions, approvedBy, notes }) => {
    return apiClient.post('/distribution/approve', {
      troncRecordIds,
      distributionRuleId,
   allocations,
      distributions, // Include distributions for backward compatibility
approvedBy,
      notes
    });
  },

  /**
   * Get all employee allocations with optional filters
   */
  getAllocations: (filters = {}) => {
    return apiClient.get('/distribution/allocations', filters);
  },

  /**
   * Get allocations for a specific employee
   */
  getEmployeeAllocations: (employeeId, params = {}) => {
    return apiClient.get(`/distribution/allocations/employee/${employeeId}`, params);
  },

  /**
   * Get distribution history with optional filters
   */
  getHistory: (params = {}) => {
    return apiClient.get('/distribution/history', params);
  },

  /**
   * Get distribution history with location/date filters.
   * Convenience wrapper around getHistory for the dashboard.
   */
  getDistributionHistory: async (locationId = null, fromDate = null, toDate = null) => {
    const params = {};
    if (locationId) params.locationId = locationId;
    if (fromDate) params.fromDate = fromDate.toISOString();
    if (toDate) params.toDate = toDate.toISOString();

    return apiClient.get('/distribution/history', params);
  },

  /**
   * Get distribution by ID
   */
  getById: (id) => {
  return apiClient.get(`/distribution/${id}`);
  },

  /**
   * Get detailed distribution information for a TRONC record
   */
  getDistributionDetail: async (troncRecordId) => {
  return apiClient.get(`/distribution/detail/${troncRecordId}`);
  },

  /**
   * Get employee tronc summary
   */
  getEmployeeTroncSummary: (employeeId, params = {}) => {
    return apiClient.get(`/distribution/employee/${employeeId}/summary`, params);
  },

  /**
   * Get employee TRONC summary with optional date range.
   * Convenience wrapper around getEmployeeTroncSummary.
   */
  getEmployeeSummary: async (employeeId, fromDate = null, toDate = null) => {
    const params = {};
    if (fromDate) params.fromDate = fromDate.toISOString();
    if (toDate) params.toDate = toDate.toISOString();

    return apiClient.get(`/distribution/employee/${employeeId}/summary`, params);
  },
};

export default distributionApi;
